export const modelFields = {
  SocialMedia: ["title", "link", "type"],
  Section: ["branch_id", "name", "image"],
  Category: ["section_id", "name", "image"],
  Product: [
    "name",
    "description",
    "image",
    "price",
    "price_offer",
    "new",
    "popular",
    "unavailable",
    "hidden",
  ],
  Branch: [
    "name",
    "phone",
    "mobile",
    "address",
    "address_link",
    "active",
    "image",
  ],
  Notification: ["title", "description", "image", "type"],
  Option: ["product_id", "name"],
  Order: [
    "total",
    "payment_method",
    "status",
    "table_id",
    "branch_id",
    "note",
    "delivary_fees",
    "time_takeaway",
    "type",
    "order_number",
    "final_total",
    "discount_value",
    "wallet_amount",
    "coupon_id",
  ],
  Setting: [
    "hidden_status_order",
    "free_delivery_min_total",
    "range_distance",
    "price_per_range",
    "bonus_ratio",
    "max_points_usage_percentage",
    "first_register_coupon_id",
    "opening_time",
    "closing_time",
  ],
  SubOption: ["option_id", "name", "price"],
  User: ["name", "phone", "role", "status"],
  Coupon: [
    "code",
    "type",
    "value",
    "max_uses",
    "is_active",
    "starts_at",
    "expires_at",
    "minimum_order_amount",
    "is_first_register",
    "is_free_delivery",
    "description",
  ],
  Customer: [
    "phone",
    "image",
    "wallet",
    "status",
    "name",
    "email",
  ],
  Table: [
    "branch_id",
    "table_number",
  ],
};